import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import { SegmentDependencyOverview } from '../models/segments';
import { TableSortState } from '../models/tableSortState';
import { AppContext, AppProviderDispatch } from '../shared/app-context';
import useRestService from '../shared/rest-service';

/**
 * Hook to fetch a client user a list of depemdencies for a segment
 */
export function useSegmentDependencies(segmentId: string, sort: TableSortState) {
  const appState = React.useContext<AppProviderDispatch>(AppContext);
  const { fetchWrapper } = useRestService();

  return useQuery<SegmentDependencyOverview, Error>(
    ['dependencies', appState.state.clientId, segmentId, sort],
    () => {
      let query =
        `Page=${sort.page}` +
        `&PageSize=${sort.pageSize}` +
        `&Sort=${sort.orderColumn}` +
        `&SortDirection=${sort.orderDirection}`;

      return fetchWrapper(`api/${appState.state.clientId}/segments/${segmentId}/dependencies?${query}`);
    },
    {
      keepPreviousData: true
    }
  );
}
